// Mock pricing configuration data for Itanta PTI Pricing Estimator

export const TIERS = [
  {
    id: 'lite',
    label: 'POC Tier',
    name: 'Itanta Lite',
    price: 100,
    priceLabel: '$100',
    perLabel: '/mo',
    tagline: 'Prove the concept on a single line',
    includedCreators: 1,
    includedViewers: 1,
    maxApps: 1,
    maxTags: 1000,
    additionalCreatorPrice: 333,
    datasourcesPerConnector: 2,
    freeTrial: true,
  },
  {
    id: 'business',
    label: 'Departmental Tier',
    name: 'Itanta Business',
    price: 999,
    priceLabel: '$999',
    perLabel: '/mo',
    tagline: 'Roll out across a department',
    includedCreators: 2,
    includedViewers: 3,
    maxApps: 3,
    maxTags: 10000,
    additionalCreatorPrice: 200,
    datasourcesPerConnector: 5,
    freeTrial: false,
  },
  {
    id: 'professional',
    label: 'Full Site Tier',
    name: 'Itanta Professional',
    price: 2999,
    priceLabel: '$2,999',
    perLabel: '/mo',
    tagline: 'Blanket an entire plant site',
    includedCreators: 5,
    includedViewers: 5,
    maxApps: 10,
    maxTags: 50000,
    additionalCreatorPrice: 100,
    datasourcesPerConnector: 'Unlimited',
    freeTrial: false,
  },
  {
    id: 'enterprise',
    label: 'Corporate Tier',
    name: 'Itanta Enterprise',
    price: null,
    priceLabel: 'Custom',
    perLabel: '',
    tagline: 'Multi-site, custom ELA',
    includedCreators: 'Tailor-made',
    includedViewers: 'Tailor-made',
    maxApps: 'Unlimited',
    maxTags: 'Unlimited',
    additionalCreatorPrice: 'Custom',
    datasourcesPerConnector: 'Unlimited',
    freeTrial: false,
  },
];

export const VIEWER_PRICE = 20;
export const APP_PRICE = 50;
export const TAG_PACK_PRICE = 10;
export const ANNUAL_DISCOUNT = 0.15;

export const HISTORIAN_OPTIONS = [
  {
    id: 'none',
    name: 'None — built-in connectors are enough',
    price: 0,
    perLabel: '',
    description: '',
  },
  {
    id: 'single',
    name: 'Single Historian',
    price: 5000,
    perLabel: '/ year',
    description: 'Pick 1 · AVEVA PI, IP21, Canary Labs, or GE Proficy',
  },
  {
    id: 'dual',
    name: 'Dual Historian',
    price: 8000,
    perLabel: '/ year',
    description: 'Pick 2 (any combo) · save $2,000 vs two singles',
  },
];

export const DASHBOARD_OPTIONS = [
  {
    id: 'none',
    name: "No templates — I'll build my own dashboards",
    price: 0,
    perLabel: '',
    description: '',
  },
  {
    id: 'starter',
    name: 'Starter',
    price: 999,
    perLabel: 'one-time',
    description: '5 essential dashboards · OEE, downtime, throughput',
  },
  {
    id: 'standard',
    name: 'Standard',
    price: 2499,
    perLabel: 'one-time',
    description: '12 industry-specific · quality, energy, maintenance',
  },
  {
    id: 'advanced',
    name: 'Advanced',
    price: 4999,
    perLabel: 'one-time',
    description: '20+ dashboards · predictive analytics + custom KPIs',
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    price: 10000,
    perLabel: 'one-time',
    description: 'Full domain library + customization sprint',
  },
];

export const COMPARE_ROWS = [
  { label: 'Base price', key: 'priceLabel', suffix: '/mo', special: true },
  { label: 'Included concurrent creator seats', key: 'includedCreators' },
  {
    label: 'Additional creator seat',
    key: 'additionalCreatorPrice',
    prefix: '$',
    suffix: '/mo',
  },
  { label: 'Included view-only seats', key: 'includedViewers' },
  { label: 'Additional view-only seat', value: '$20/user/mo' },
  { label: 'Max applications', key: 'maxApps' },
  { label: 'Extra application add-on', value: '$50/app/mo' },
  { label: 'Max data tags / parameters', key: 'maxTags' },
  { label: 'Extra tag pack (100 tags)', value: '$10/pack/mo' },
  {
    label: 'Datasources per connector (files / tables / endpoints)',
    key: 'datasourcesPerConnector',
  },
  { label: 'All connectors included', check: true },
  { label: '15-day free trial', check: 'freeTrial' },
];
